import { fromJS, List, Map } from 'immutable';
import BoostRecord from 'records/boost';
import CampaignRecord from 'records/campaign';
import CategoryRecord from 'records/category';
import CompanyRecord from 'records/company';
import EmailSettingsRecord from 'records/emailSettings';
import FollowUpRecord from 'records/followUp';
import KeywordRecord from 'records/keyword';
import ListingRecord from 'records/listing';
import MeRecord from 'records/me';
import MediumRecord from 'records/medium';
import OrderRecord from 'records/order';
import PageRecord from 'records/page';
import ProductRecord from 'records/product';
import PromotionRecord from 'records/promotion';

export const mapListing = (l) => {
    const listing = fromJS(l) || Map({});
    const price = Number(listing.get('price'));

    return ListingRecord(
        listing.set('price', !Number.isNaN(price) && price ? price.toFixed(2) : listing.get('price'))
    );
};

export const mapMe = (m) => {
    return MeRecord(fromJS(m) || Map());
};

export const mapOrder = (o) => {
    const order = fromJS(o) || Map();
    const campaign = CampaignRecord(order.get('campaign', Map()));
    const promotion = PromotionRecord(order.get('promotion', Map()));

    return OrderRecord(
        order.set('campaign', campaign).set('promotion', promotion)
    );
};

export const mapPage = (p) => {
    const page = fromJS(p) || Map();
    const medium = MediumRecord(page.get('medium', Map()));

    return PageRecord(
        page.set('medium', medium)
    );
};

export const mapProduct = (p) => {
    const product = fromJS(p);
    const categories = product.get('categories', List([])).map(CategoryRecord);
    const keywords = product.get('keywords', List([])).map(KeywordRecord);
    const listings = product.get('listings', List([])).map(mapListing);
    const media = product.get('media', List([])).map(MediumRecord);

    return ProductRecord(
        product.set('categories', categories)
            .set('keywords', keywords)
            .set('listings', listings)
            .set('media', media)
    );
};

export const mapCampaign = (c) => {
    const campaign = fromJS(c) || Map();
    const b = campaign.get('boost');
    const boost = b ? BoostRecord(b) : null;
    const company = CompanyRecord(campaign.get('company'), Map());
    const emailSettings = EmailSettingsRecord(campaign.get('emailSettings', Map()));
    const followUps = campaign.get('followups', List()).map(FollowUpRecord);
    const listing = mapListing(campaign.get('listing', Map()));
    const page = mapPage(campaign.get('page', Map()));
    const product = mapProduct(campaign.get('product', Map()));

    return CampaignRecord(
        campaign
            .set('boost', boost)
            .set('company', company)
            .set('emailSettings', emailSettings)
            .set('followups', followUps)
            .set('listing', listing)
            .set('page', page)
            .set('product', product)
    );
};



// WEBPACK FOOTER //
// ./src/utils/mapToRecord.js